import {
    VIEW_END_LOADING,
    VIEW_START_LOADING
} from "./actions.type"

const initialState = {
    isLoading: false
}

export const state = { ...initialState };

export const actions = {
    async[VIEW_START_LOADING](context) {
        context.commit("Loading", true);
    },
    async[VIEW_END_LOADING](context) {
        context.commit("Loading", false);
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
    Loading(state, s) {
        state.isLoading = s;
    },
};

const getters = {
    isLoading(state) {
        return state.isLoading;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
